module.exports = __webpack_public_path__ + "img/quality.f5ee6b5a.jpg";